import React from 'react';
import PropTypes from 'prop-types';
import { CForm, CCard, CCardBody, CButton, CSpinner, CRow, CCol } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSave } from '@coreui/icons';

import AlertTypes from './components/AlertTypes';
import MessengerSettings from './components/MessengerSettings';
import ReportSchedule from './components/ReportSchedule';
import ReportScope from './components/ReportScope';
import AnalyticalPrediction from './components/AnalyticalPrediction';

const AlertsSettings = ({ config, setConfig, devices, workZones, onSave, saving }) => {
  const updateConfig = (updates) => {
    setConfig((prev) => ({ ...prev, ...updates }));
  };

  return (
    <CForm className="d-flex flex-column gap-4 pb-5">
      
      {/* ШАГ 1: ВЫБОР ТЕХНИКИ */}
      <div>
        <h5 className="fw-bold text-primary mb-3">1. Зона мониторинга (Техника и Участки)</h5>
        <ReportScope
          config={config}
          updateConfig={updateConfig}
          devices={devices}
          workZones={workZones}
        />
      </div>

      {/* ШАГ 2: КАНАЛЫ ДОСТАВКИ */}
      <div>
        <h5 className="fw-bold text-primary mb-3">2. Каналы получения уведомлений</h5>
        <MessengerSettings config={config} updateConfig={updateConfig} />
      </div>

      {/* ШАГ 3: НАСТРОЙКА СОБЫТИЙ И ОТЧЕТОВ */}
      <div>
        <h5 className="fw-bold text-primary mb-3">3. Правила и расписание отправки</h5>
        <CRow className="g-4">
          <CCol xl={5} lg={12}>
            {/* Моментальные алерты */}
            <AlertTypes config={config} updateConfig={updateConfig} />
          </CCol>
          <CCol xl={7} lg={12}>
            {/* Регулярные отчеты */}
            <CCard className="shadow-sm border-0 bg-white h-100">
              <CCardBody className="p-3">
                <div className="mb-3">
                  <h6 className="fw-bold text-dark mb-1">Сводные отчеты в Excel</h6>
                  <p className="text-muted small mb-0">
                    Система автоматически сформирует и пришлет статистику по выбранной выше технике.
                  </p>
                </div>
                <ReportSchedule config={config} updateConfig={updateConfig} />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>

      {/* ШАГ 4: ПЛАН/ФАКТ */}
      <div>
        <h5 className="fw-bold text-primary mb-3">4. Предиктивная аналитика (Контроль норм)</h5>
        <AnalyticalPrediction config={config} setConfig={setConfig} devices={devices} />
      </div>

      {/* КНОПКА СОХРАНЕНИЯ */}
      <div className="position-sticky bottom-0 bg-light py-3 border-top mt-4 text-end" style={{ zIndex: 100 }}>
        <CButton
          color="primary"
          size="lg"
          onClick={onSave}
          disabled={saving}
          className="fw-bold shadow"
        >
          {saving ? (
            <CSpinner size="sm" className="me-2" />
          ) : (
            <CIcon icon={cilSave} className="me-2" />
          )}{' '}
          Сохранить все настройки
        </CButton>
      </div>
    </CForm>
  );
};

AlertsSettings.propTypes = {
  config: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired,
  devices: PropTypes.array.isRequired,
  workZones: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
};

export default AlertsSettings;